import { useContext } from "react";
import { EBSSSInjectorContext } from ".";
import { IEBSSSInjectorContext } from "./types";

export const useEBSSSInjector = () => useContext<IEBSSSInjectorContext>(EBSSSInjectorContext);
